import { render, staticRenderFns } from "./Gov.vue?vue&type=template&id=0faa5146"
import script from "./Gov.vue?vue&type=script&lang=ts"
export * from "./Gov.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports